import AccountAdminsList from "../components/AccountAdminsList.svelte"
import register from "~/lib/registerSvelte";

// Mounted via data-svelte-component in User/Edit.jst.ejs
register({ AccountAdminsList });